<template>

    <div>

        <div class="card-wrap">

            <ClearDb></ClearDb>
        </div>
        <div class="card-wrap" v-if=" allRoles.length > 1 ">

            <RoleSwitch></RoleSwitch>
        </div>
        <!-- <div class="card-wrap" v-if=" installableApp ">

            <InstallWebapp></InstallWebapp>
        </div> v-if=" environment == 'Local' " -->
        <div class="card-wrap" >

            <h1>Developer</h1>
            <p>UserAgent: {{ this.UserAgent }}</p>
            <p>AppVersion: {{ this.AppVersion }}</p>
            <p>Product: {{ this.Product }}</p>
            <p>AppCodeName: {{ this.AppCodeName }}</p>
            <br />
            <p style="font-weight: bold">hasIndexDB: <span style="color: blue">{{ this.hasIndexDB }}</span></p>
            <p style="font-weight: bold">hasPaymentApi: <span style="color: blue">{{ this.hasPaymentApi }}</span></p>
        </div>
    </div>

</template>

<script>

    import { mapGetters } from 'vuex';
    import InstallWebapp from './InstallWebapp';
    import RoleSwitch from './RoleSwitch';
    import ClearDb from './ClearDb';

    export default {

        name: 'settings',
        data: function(){

            return {

                UserAgent     : navigator.userAgent,
                AppVersion    : navigator.appVersion,
                Product       : navigator.product,
                AppCodeName   : navigator.appCodeName,
                hasIndexDB    : ( 'indexedDB' in window ),
                hasPaymentApi : !!( window.PaymentRequest )
            }
        },
        computed: {

            ...mapGetters({

                allRoles       : 'auth/allRoles',
                installableApp : 'pwa/installableApp',
                tabOpen        : 'orderTab/tabOpen',
                environment    : 'environment'
            })
        },
        components: {

            InstallWebapp,
            RoleSwitch,
            ClearDb
        }

    }

</script>

<style scoped>

</style>